import {
	Box,
	Checkbox,
	IconButton,
	Menu,
	MenuItem,
	TableCell,
	TableRow,
	Typography
} from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';
import { Image } from 'components';
import { useMenu } from 'hooks';
import React from 'react';

const ArticleItem = ({
	article,
	isSelectable,
	selectedIds = [],
	handleSelect,
	handleClick,
	handleEditClick,
	handleDeleteClick,
	...props
}) => {
	const { open, anchorEl, handleToggleMenu, handleClose } = useMenu();

	const renderMenu = () => (
		<Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
			<MenuItem onClick={(e) => handleEditClick(article, e)}>Edit</MenuItem>
			<MenuItem onClick={(e) => handleDeleteClick(article, e)}>Delete</MenuItem>
		</Menu>
	);

	const isSelected = selectedIds.includes(article.id);

	return (
		<TableRow
			hover
			onClick={() => handleClick(article)}
			sx={{ cursor: 'pointer' }}
		>
			{isSelectable && (
				<TableCell>
					<Checkbox
						checked={isSelected ? true : false}
						onChange={() => handleSelect(article)}
						name="article"
						color="primary"
					/>
				</TableCell>
			)}
			<TableCell>
				<Image src={article.image_url} variant="rounded" size={80} />
			</TableCell>
			<TableCell>
				<Typography variant="body2">{article.title}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="body2">{article.category}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="body2">{article.published_at}</Typography>
			</TableCell>
			<TableCell align="right">
				<IconButton
					onClick={(e) => {
						e.stopPropagation();
						handleToggleMenu(e);
					}}
				>
					<MoreHoriz />
				</IconButton>
				{renderMenu()}
			</TableCell>
		</TableRow>
	);
};

export default ArticleItem;
